import { createElement } from 'react';

const SvgChevronRight = (props) => (createElement("svg", Object.assign({ width: "1em", height: "1em", viewBox: "0 0 8 16", fill: "none" }, props),
    createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M7.797 7.462c.27.307.27.76 0 1.068l-6.315 7.183a.858.858 0 01-1.188.09.806.806 0 01-.091-1.157l5.846-6.65L.203 1.356A.806.806 0 01.293.198a.858.858 0 011.188.088l6.316 7.176z", fill: "currentColor" })));

export default SvgChevronRight;
